const datagridRowClassPrefix = 'on-demand-programme-window';
const colorCodes = [
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#FF33A8',
    '#A833FF',
    '#33FFF5',
    '#F5FF33',
    '#FF8C33',
    '#8C33FF',
    '#33FF8C',
    '#FF3333',
    '#33FF33',
    '#3333FF',
    '#FF33FF',
    '#33FFFF',
    '#FFFF33',
    '#FFA533',
    '#A5FF33',
    '#33FFA5',
    '#5733FF',
    '#33A5FF',
    '#FF338C',
    '#338CFF',
    '#8CFF33',
    '#33FF33',
    '#FF5733',
    '#33FF57',
    '#5733FF',
    '#F5A623',
    '#23F5A6',
    '#A623F5',
    '#F523A6',
    '#A6F523',
    '#23A6F5',
    '#F5A623',
    '#F57F23',
    '#A6F523',
    '#23F57F',
    '#7F23F5',
    '#23A6F5',
    '#F57FA6',
    '#A6F57F',
    '#7FA6F5',
    '#A67FF5',
    '#F57FA6',
    '#A67FF5',
    '#7FF5A6',
    '#F57FA6',
    '#7FF5A6',
    '#A67FF5',
];
const getColorIndexForWindow = (window) => {
    return window % colorCodes.length;
};
export const getColorCodeForWindow = (window) => {
    const index = getColorIndexForWindow(window);
    const color = colorCodes[index];
    return color;
};
export const getDataGridRowClassForWindow = (window) => {
    const index = getColorIndexForWindow(window);
    return `${datagridRowClassPrefix}_${index}`;
};
export const getStylesForColorCodes = (programme) => {
    const windows = programme.windows ?? 1;
    const styles = [];
    for (let i = 0; i < windows; i++) {
        const color = getColorCodeForWindow(i);
        styles.push({
            ['& .' + getDataGridRowClassForWindow(i)]: {
                backgroundColor: `color-mix(in oklab, ${color}, transparent 65%)`,
                ['&:hover']: {
                    backgroundColor: `color-mix(in oklab, ${color}, transparent 50%)`,
                },
                ['&.Mui-selected']: {
                    backgroundColor: `color-mix(in oklab, ${color}, transparent 65%)`,
                    ['&:hover']: {
                        backgroundColor: `color-mix(in oklab, ${color}, transparent 50%)`,
                    },
                },
            },
        });
    }
    return styles;
};
